import type { ComponentInstance } from '@sapappgyver/appgyver-descriptors/lib/dolan/v4';
import generateDeterministicUuid from '../../../utilities/generateDeterministicUuid';

/**
 * Generates a new unique component instance ID that should be used for a new component instance.
 * The ID is deterministic but unique as long this is given the root component instance
 * of the whole structure, where the uniqueness is required. The root component should
 * typically be the `view.layout.root_component`.
 * @param view view to which the new component instance is to be added
 */
export default function generateDeterministicComponentInstanceId(
  baseId: string | number,
  rootComponent: ComponentInstance,
): string {
  const allComponentInstanceIds = getAllComponentIds(rootComponent);
  return generateDeterministicUuid([String(baseId), ...allComponentInstanceIds]);
}

function getAllComponentIds(rootComponent: ComponentInstance): string[] {
  const ids: string[] = [rootComponent.id];
  rootComponent.children.forEach((child) => {
    ids.push(...getAllComponentIds(child));
  });
  return ids;
}
